module.exports = __webpack_public_path__ + "static/media/p2p_finance.b5f1d909.svg";